import React, { useEffect } from 'react'
import Modal from '../../Modal'
import Text from '../../Text'
import Youtube from '../../Youtube'
import Spacer from '../../Spacer'
import CategoryTitle from '../../CategoryTitle'
import SimpleBlockContent from '../../SimpleBlockContent'
import styles from './styles.module.css'
import { $neutralGray80, $white } from '../../../styles/colors/primitives'



function SimplePictureAndText({ sideImage, theme = {}, title, text, reversed, containImage }) {
  const themeColorValue = theme.title.match(/\d+/) ? Number(theme.title.match(/\d+/)[0]) : null
  const textColor = themeColorValue && themeColorValue > 40 ? $white : $neutralGray80
  const dark = themeColorValue && themeColorValue < 50

  // Runtime/prop-driven values -> inline style (matches former styled `${props}`).
  const sideImageStyle = {
    backgroundImage: sideImage?.src ? `url(${sideImage.src})` : undefined,
    backgroundSize: containImage ? 'contain' : 'cover',
    backgroundPosition: reversed ? 'center right' : 'center left'
  }

  return (
    <div className={styles.wrapper} style={{ backgroundColor: theme.value }}>
      <div className={styles.contentWrapper}>
        <div className={styles.sideImageWrapper}>
          {/* task #67: styled bg fed the resolved descriptor url */}
          <div className={styles.sideImage} style={sideImageStyle} />
        </div>
        <div className={reversed ? `${styles.textWrapper} ${styles.reversed}` : styles.textWrapper}>
          <Spacer size={64} />
          <div style={{ color: textColor }}><Text type="H1">{title}</Text></div>
          <Spacer size={32} />
          <div style={{ color: textColor }}>
            {text && <SimpleBlockContent blocks={text} />}
          </div>
          <Spacer size={160} />
        </div>
      </div>
    </div>
  )
}

export default SimplePictureAndText
